import { Checkbox, Col, Row } from "antd";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { ignoreSelectJobSelector } from "../../../store/var/var.selector";
import { ignoreSelectJob } from "../../../store/var/var.action";
const IncomeStaffJob = (props) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const checked = useSelector(ignoreSelectJobSelector);
  // console.log({ checked });
  // -------------------------- FUNCTION --------------------------
  const onChange = (e) => {
    console.log(`checked = ${e.target.checked}`);
    const update = !e.target.checked;
    dispatch(ignoreSelectJob({ data: update }));
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  return (
    <Row gutter={[10, 10]} justify="end" align="middle">
      <Col>
        <Checkbox onChange={onChange} checked={!checked}>
          Add income from Job List
        </Checkbox>
      </Col>
    </Row>
  );
};
export default IncomeStaffJob;
